/* global window._appConstants */
import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
// import clsx from "clsx";
import { makeStyles } from "@material-ui/core/styles";
import PropTypes from "prop-types";
import ErrorBoundary from "./ErrorBoundary";
import { Topbar, Sidebar, Breadcrumbs, ScrollToTop } from "./components";
import { Grid, Paper } from "@material-ui/core";
import TokenStorage from "../../js/utils/tokenStorage";
import { OAuth as OAuthActions } from "../../js/actions";
import Modal from "@material-ui/core/Modal";
import {
  Typography,
  // TextField,
  // InputAdornment,
  // IconButton,
  Checkbox,
  Chip
} from "@material-ui/core";
import ExitToAppIcon from "@material-ui/icons/ExitToApp";
import { FooterTabs } from "../../../src/components/index";

import { UserProfile } from "../../components";
import { UserProfile as UserProfileActions } from "../../js/actions";
import { useHistory } from "react-router-dom";
import { setSnackbar } from "../../js/reducers/snackbar";
import { setAlertDialog } from "../../js/reducers/alertDialog";
import { Context } from "../../js/utils//Context.js";
import { withRouter } from "react-router-dom";

import ReactGA from "react-ga";

ReactGA.initialize("GTM-5RK9R65");

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
  },
  menuClosed: {
    maxWidth: "65px",
  },
  dashboardWidth: {
    maxWidth: "calc(100% - 65px)",
    flexBasis: "calc(100% - 65px)",
    height: "100vh",
    overflow: "auto",
  },
  dashboardWidthOpen: {
    maxWidth: "calc(100% - 240px)",
    flexBasis: "calc(100% - 240px)",
    height: "100vh",
    overflow: "auto",
  },
  dialogStyle: {
    maxWidth: "100%",
    flexBasis: "calc(100%)",
    height: "100vh",
    overflow: "auto",
  },
  consentOverlay: {
    position: "fixed",
    inset: 0,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backdropFilter: "blur(4px)",
    backgroundColor: "rgba(15,23,42,0.35)",
    zIndex: 999,
    padding: "1.5rem",
  },
  consentCard: {
    width: "100%",
    maxWidth: "520px",
    backgroundColor: "#fff",
    borderRadius: "16px",
    boxShadow: "0 4px 12px rgba(0,0,0,0.08), 0 12px 40px rgba(0,0,0,0.12)",
    overflow: "hidden",
    fontFamily: "Bosch Sans Regular",
  },
  consentBanner: {
    background: "#F8FAFC",
    borderBottom: "1px solid #e2e8f0",
    padding: "20px",
    textAlign: "center",
  },
  consentBannerIcon: {
    width: "72px",
    height: "72px",
    borderRadius: "50%",
    background: "linear-gradient(135deg, #1a56db 0%, #1e40af 100%)",
    border: "3px solid #dbeafe",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    margin: "0 auto 12px",
    boxShadow: "0 4px 12px rgba(26,86,219,0.25)",
  },
  consentBannerTitle: {
    color: "#0f172a",
    fontWeight: 700,
    fontSize: "18px !important",
    margin: "0 0 6px",
    letterSpacing: "0.02em",
  },
  consentBannerSub: {
    color: "#64748b",
    fontSize: "13px !important",
    lineHeight: 1.5,
    margin: 0,
  },
  consentBody: {
    padding: "20px 20px 0 20px",
    display: "flex",
    flexDirection: "column",
    gap: "12px",
  },
  consentRow: {
    border: "1px solid #e2e8f0",
    borderRadius: "12px",
    padding: "14px 16px",
    display: "flex",
    alignItems: "center",
    gap: "12px",
    transition: "border-color 0.15s, background-color 0.15s",
    "&:hover": {
      borderColor: "#1a56db",
      backgroundColor: "#f8fafc",
    },
  },
  consentRowText: {
    flex: 1,
  },
  consentRowTitle: {
    color: "#0f172a",
    fontWeight: 600,
    fontSize: "14px !important",
    margin: "0 0 2px",
  },
  consentRowDesc: {
    color: "#64748b",
    fontSize: "12px !important",
    lineHeight: 1.5,
    margin: 0,
  },
  consentLink: {
    color: "#1a56db",
    fontWeight: 600,
    textDecoration: "underline",
    cursor: "pointer",
    fontStyle: "normal",
  },
  consentFooter: {
    padding: "14px 20px",
    borderTop: "1px solid #e2e8f0",
    display: "flex",
    justifyContent: "flex-end",
    gap: "10px",
  },
  consentLogoutBtn: {
    display: "inline-flex",
    alignItems: "center",
    gap: "7px",
    background: "#fff",
    color: "#0f172a",
    fontSize: "13px !important",
    fontWeight: 600,
    padding: "9px 18px",
    borderRadius: "8px",
    border: "1px solid #e2e8f0",
    cursor: "pointer",
    letterSpacing: "0.02em",
    transition: "all 0.15s",
    "&:hover": {
      backgroundColor: "#f1f5f9",
      borderColor: "#cbd5e1",
    },
  },
  consentAcceptBtn: {
    display: "inline-flex",
    alignItems: "center",
    gap: "7px",
    background: "linear-gradient(135deg, #1a56db 0%, #1e40af 100%)",
    color: "#fff",
    fontSize: "13px !important",
    fontWeight: 600,
    padding: "9px 20px",
    borderRadius: "8px",
    border: "none",
    cursor: "pointer",
    letterSpacing: "0.02em",
    boxShadow: "0 2px 8px rgba(26,86,219,0.35)",
    transition: "all 0.15s",
    "&:hover": {
      boxShadow: "0 4px 14px rgba(26,86,219,0.45)",
      transform: "translateY(-1px)",
    },
    "&:disabled": {
      background: "#cbd5e1",
      boxShadow: "none",
      cursor: "not-allowed",
      transform: "none",
    },
  },
  consentExitIcon: {
    fontSize: "16px !important",
  },
  content: {
    flexGrow: 1,
    paddingTop: theme.spacing(2),
    height: "100%",
  },
  headerHeight: {
    display: "flex",
    alignItems: "center",
    // necessary for content to be below app bar
    ...theme.mixins.toolbar,
    justifyContent: "flex-end",
  },
  makeWrap: {
    padding: "2px",
    position: "relative",
    background: "linear-gradient(to right, #EA0016, #B90276,#50237F)",
  },
  module: {
    backgroundColor: "white",
    padding: "2px",
  },
}));

const Main = (props) => {
  const { children } = props;
  const classes = useStyles();

  const [make, setMake] = useState({ uid: "", name: "Not Selected" });

  const [role, setRole] = useState({});
  const [open, setOpen] = React.useState(false);
  const dispatch = useDispatch();
  const history = useHistory();
  let intervlToRefreshToken;
  const [OpenDialogue, setOpenDialogue] = React.useState(true);
  const [termsOfUse, setTermsOfUse] = React.useState(false);
  const [privacyPolicy, setPrivacyPolicy] = React.useState(false);
  const [openTerms, setOpenTerms] = React.useState(false);
  const [openPrivacy, setOpenPrivacy] = React.useState(false);
  const oAuthData = useSelector((state) => state.OAuth.authData || {});

  const data = useSelector((state) => {
    // debugger;
    console.log(
      "state.OAuth.loginUserData useSelector",
      state.OAuth.loginUserData
    );
    return state.OAuth.loginUserData || {};
  });

  // Re-open the consent dialog whenever the acceptance flags become false
  // (e.g. after a new policy upload resets them). OpenDialogue is only ever
  // set to false on accept/logout, so it must be reset here to show again.
  useEffect(() => {
    if (
      data &&
      (data.hasAcceptedPrivacyPolicy === false ||
        data.hasAcceptedTnc === false)
    ) {
      setOpenDialogue(true);
    }
  }, [data.hasAcceptedPrivacyPolicy, data.hasAcceptedTnc]);

  const handlePrivacyUpdate = async () => {
    // setOpenDialogue(false);
    await dispatch(
      OAuthActions.updateUsersPolicy(data.uid, {
        hasAcceptedTnc: true,
        hasAcceptedPrivacyPolicy: true,
      })
    ).then(function (userDetails) {
      if (userDetails["error"] === undefined) {
        setTermsOfUse(false);
        setPrivacyPolicy(false);
        dispatch(setSnackbar(true, "success", "Update Successful"));
        handleClose();
        dispatch(OAuthActions.getLoginUser(data.uid)).then(function (flag) { });
      } else dispatch(setAlertDialog(true, null, "error", "Update User", "Update unsuccessful.\nDetails Of Failure: " + userDetails.message, "OK", ""));
    });
  };
  const handleTermsClose = () => {
    setOpenTerms(false);
  };
  const handlePrivacyClose = () => {
    setOpenPrivacy(false);
  };
  const handleClickOpen = () => {
    setOpenTerms(true);
  };
  const handleClickPrivacyOpen = () => {
    setOpenPrivacy(true);
  };
  const logout = () => {
    handleClose();
    localStorage.removeItem("token_name");
    dispatch(UserProfileActions.clearLoginUserData()).then(function () {
      history.push(window._appConstants.useCommonDefaults.navRef.login);
    });
  };
  const handleClose = () => {
    setOpenDialogue(false);
  };

  useEffect(() => {
    const val = TokenStorage.getCurrentMakeSelected();
    if (val.uid != undefined || val.uid != "") {
      setMake(val);
    }
    console.log("Main.js useEffect", val);

    console.log("React GA trigger");

    ReactGA.pageview(window.location.pathname + window.location.search);
    dispatch(OAuthActions.getLoginUser(data.uid)).then(function (flag) {
      console.log("Main.js Flag", flag);
      console.log("data.role", data.role.name);
      const val = JSON.parse(
        JSON.stringify(JSON.parse(TokenStorage.getCurrentMakeSelected()))
      );
      if (val.uid != undefined || val.uid != "") {
        console.log("New change", val);
        setMake(val);
      } else setMake(data.make != undefined || data.make != null ? data.make : { uid: "", name: "Not Selected" });
    });
  }, []);

  useEffect(() => {
    if (data.make != undefined || data.make != null) {
      console.log("Main.js: useEffect data", data.make.name);
      const makeDetails = data.make;
      console.log("Main.js: useEffect data makeDetails", makeDetails);
      setMake(makeDetails);
    } else setMake({ uid: "", name: "Not Selected" });
  }, [data.make]);
  useEffect(() => {
    //

    console.log("Main.js: Oauth Data", oAuthData);

    console.log("Main.js: data Data", data);

    if (data != undefined) {
      if (data.make != null) {
        console.log("Main.js: data.make.name", data.make.name);
        setMake(data.make);
      } else setMake({ uid: "", name: "Not Selected" });
      if (data.hasAcceptedTnc) setTermsOfUse(true);
      if (data.hasAcceptedPrivacyPolicy) setPrivacyPolicy(true);
    } else setMake({ uid: "", name: "Not Selected" });
    //
    clearInterval(intervlToRefreshToken);
    let expires_in_count = 0,
      dtSeconds = 0;
    if (!oAuthData.refresh_token && TokenStorage.getRefreshToken()) {
      let curDate = new Date();
      let expiryDate = new Date(TokenStorage.getTokenExpirationTime());
      dtSeconds = Math.ceil((expiryDate.getTime() - curDate.getTime()) / 1000);
    } else {
      //TokenStorage.storeToken(oAuthData.access_token);
      TokenStorage.storeRefreshToken(oAuthData.refresh_token);
      let dt = new Date();
      //oAuthData.expires_in = 240;
      dt.setSeconds(dt.getSeconds() + oAuthData.expires_in);
      TokenStorage.setTokenExpirationTime(dt);
    }
    intervlToRefreshToken = setInterval(() => {
      if (
        expires_in_count <
        (oAuthData.expires_in ? oAuthData.expires_in : dtSeconds)
      ) {
        expires_in_count++;
      } else {
        clearInterval(intervlToRefreshToken);
        expires_in_count = 0;
        dispatch(
          OAuthActions.refreshOAuthToken(TokenStorage.getRefreshToken())
        );
      }
    }, 1000);
    return () => {
      clearInterval(intervlToRefreshToken);
    }; //component will unmount
  }, [oAuthData]);

  const toggleSidebarHandler = (event, newValue) => {
    event.preventDefault();
    setOpen(newValue);
  };
  const onChange = (event) => {
    switch (event.target.id) {
      case "termsOfUse":
        setTermsOfUse(event.target.checked);
        break;
      case "privacyPolicy":
        setPrivacyPolicy(event.target.checked);
        break;
      default:
        break;
    }
  };

  window.addEventListener(
    "storage",
    function (event) {
      if (event.key == "logout-event") {
        console.log("Received logout event! Insert logout script here.");
        // window.location = "logout.php";
      }
    },
    false
  );

  return (
    <Grid container spacing={0}>
      <Context.Provider value={[make, setMake]}>
        <Grid item xs={12}>
          <Topbar
            isOpen={open}
            onToggle={toggleSidebarHandler}
            history={children.props.history}
          // isDashboardView={true}
          />
        </Grid>

        <Grid
          container
          spacing={0}
          style={{ height: "100vh", width: "100%", overflow: "hidden" }}
        >
          {data.hasAcceptedPrivacyPolicy && data.hasAcceptedTnc ? (
            <Grid
              className={open ? "" : classes.menuClosed}
              item
              style={{
                position: "absolute",
                top: 0,
                left: 0,
                zIndex: 1200
              }}
            >
              <Sidebar open={open} history={children.props.history} />
            </Grid>
          ) : null}

          {data.hasAcceptedPrivacyPolicy && data.hasAcceptedTnc ? (
            <Grid
              item
              id="drawercontainer"
              xs={12}
              style={{
                marginLeft: open ? "240px" : "65px",
                width: open ? "calc(100% - 240px)" : "calc(100% - 65px)",
                height: "100vh",
                overflow: "auto",
                boxSizing: "border-box"
              }}
            >
              <main>
                <div className={classes.content}>
                  <div className={classes.headerHeight} />
                  <div
                    style={{
                      background: "#fff",
                      borderBottom: "1px solid #e2e5e7",
                      paddingBottom: "12px",
                      paddingTop: "10px",
                      paddingLeft: "10px",
                    }}>
                    <Grid
                      container
                      direction="row"
                      justifyContent="space-between"
                      alignItems="center">
                      <Grid item xs>
                        <Breadcrumbs />
                      </Grid>
                      {data.role.name !== "Utility Admin" && (
                        <Chip style={{ marginRight: "10px", backgroundColor: "#1e3a8a", color: "#fff", fontWeight: 500, fontSize: 13 }}
                          label={`OEM Details: ${make.name !== "" ? make.name : "Not Selected"}`}
                          size="small"
                        />
                      )}
                    </Grid>
                  </div>
                  <Paper elevation={3} style={{ overflow: "hidden" }}>
                    <ErrorBoundary>
                      {children.type !== "p" ? children : ""}
                    </ErrorBoundary>
                    <ScrollToTop />
                  </Paper>
                </div>
              </main>
            </Grid>
          ) : null}
          {!data.hasAcceptedPrivacyPolicy || !data.hasAcceptedTnc ? (
            <Modal open={OpenDialogue}>
              <div className={classes.consentOverlay}>
                <div className={classes.consentCard}>
                  {/* Banner */}
                  <div className={classes.consentBanner}>
                    <Typography className={classes.consentBannerTitle}>
                      Accept Policies to Continue
                    </Typography>
                    <Typography className={classes.consentBannerSub}>
                      Please review and accept our updated Privacy Policy and
                      Terms &amp; Conditions to access the application.
                    </Typography>
                  </div>

                  {/* Body */}
                  <div className={classes.consentBody}>
                    {!data.hasAcceptedTnc ? (
                      <div className={classes.consentRow}>
                        <div className={classes.consentRowText}>
                          <Typography className={classes.consentRowTitle}>
                            Terms and Conditions
                          </Typography>
                          <Typography className={classes.consentRowDesc}>
                            I accept the{" "}
                            <em
                              className={classes.consentLink}
                              onClick={handleClickOpen}
                            >
                              terms and conditions
                            </em>
                          </Typography>
                        </div>
                        <Checkbox
                          id="termsOfUse"
                          checked={termsOfUse}
                          onChange={(event) => onChange(event)}
                          color="primary"
                        />
                      </div>
                    ) : (
                      <></>
                    )}
                    {!data.hasAcceptedPrivacyPolicy ? (
                      <div className={classes.consentRow}>
                        <div className={classes.consentRowText}>
                          <Typography className={classes.consentRowTitle}>
                            Privacy Policy
                          </Typography>
                          <Typography className={classes.consentRowDesc}>
                            I acknowledge the{" "}
                            <em
                              className={classes.consentLink}
                              onClick={handleClickPrivacyOpen}
                            >
                              privacy policy
                            </em>
                          </Typography>
                        </div>
                        <Checkbox
                          id="privacyPolicy"
                          checked={privacyPolicy}
                          onChange={(event) => onChange(event)}
                          color="primary"
                        />
                      </div>
                    ) : (
                      <></>
                    )}
                    {!data.hasAcceptedTnc && (
                      <FooterTabs
                        clickValue={3}
                        open={openTerms}
                        onClose={handleTermsClose}
                      />
                    )}
                    {!data.hasAcceptedPrivacyPolicy && (
                      <FooterTabs
                        clickValue={1}
                        open={openPrivacy}
                        onClose={handlePrivacyClose}
                      />
                    )}
                  </div>

                  {/* Footer */}
                  <div className={classes.consentFooter}>
                    <button onClick={logout} className={classes.consentLogoutBtn}>
                      <ExitToAppIcon className={classes.consentExitIcon} />
                      Logout
                    </button>
                    <button
                      onClick={handlePrivacyUpdate}
                      className={classes.consentAcceptBtn}
                      disabled={
                        (!data.hasAcceptedTnc && !termsOfUse) ||
                        (!data.hasAcceptedPrivacyPolicy && !privacyPolicy)
                      }
                    >
                      Accept &amp; Continue
                    </button>
                  </div>
                </div>
              </div>
            </Modal>
          ) : null}
        </Grid>
        {data.hasAcceptedPrivacyPolicy ? <UserProfile /> : null}
      </Context.Provider>
    </Grid>
  );
};

Main.propTypes = {
  children: PropTypes.node,
};

function compare(prevProps, nextProps) {
  console.log("prevProps, nextProps", prevProps, nextProps);
  return prevProps.location.pathname == nextProps.location.pathname;
}

export default withRouter(React.memo(Main, compare));
